import Cookies from 'js-cookie';
import { ComponentType, useEffect, useEffectEvent, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useLocation } from 'react-router-dom';
import CookieBanner, { CookieBannerProps } from './CookieBanner';

const COOKIE_NAME_BANNER_STATUS = 'cookieconsent_status';
const COOKIE_NAME_OPT_OUT = 'ps_tracking_opt_out';

// we can't use the environment (because of the bridge), so parsing self
const isLive = window.location.hostname.endsWith('.pirateship.com');
const domain = isLive ? '.pirateship.com' : '.' + window.location.hostname;
const secure = window.location.href.startsWith('https://');
const expires = 365;
const cookieAttributes = { expires, domain, secure };

const setCookies = (withConsent: boolean) => {
  Cookies.set(COOKIE_NAME_BANNER_STATUS, 'dismiss', cookieAttributes);
  Cookies.set(COOKIE_NAME_OPT_OUT, withConsent ? '0' : '1', cookieAttributes);
};

const isDismissed = () => Cookies.get(COOKIE_NAME_BANNER_STATUS) === 'dismiss';

type GlobalCookieBannerProps = {
  CookieBannerComponent?: ComponentType<CookieBannerProps>;
};

export default function GlobalCookieBanner({
  CookieBannerComponent = CookieBanner,
}: GlobalCookieBannerProps) {
  const location = useLocation();
  const [open, setOpen] = useState(!isDismissed());

  const onLocationChange = useEffectEvent(() => setOpen(!isDismissed()));
  useEffect(() => onLocationChange(), [location]);

  const setCookiesAndHide = (withConsent: boolean) => {
    setCookies(withConsent);
    setOpen(false);
  };

  if (!open) {
    return null;
  }

  return (
    <ErrorBoundary fallback={null}>
      <CookieBannerComponent
        onAccept={() => setCookiesAndHide(true)}
        onReject={() => setCookiesAndHide(false)}
      />
    </ErrorBoundary>
  );
}
